import {Branch} from '../models/Branch';
export const LOAD_CATEGORIES = 'LOAD_CATEGORIES';
export const LOAD_CATEGORIES_SUCCESS = 'LOAD_CATEGORIES_SUCCESS';
export const FETCH_CATEGORIES_FAILED = 'FETCH_CATEGORIES_FAILED';

export class LoadCategoriesAction {
  readonly type = LOAD_CATEGORIES;
}

export class LoadCategoriesSuccessAction {
  readonly type = LOAD_CATEGORIES_SUCCESS;
  constructor(public payload: Branch[]) { }
}

export class LoadCategoriesFailedAction { 
  readonly type = FETCH_CATEGORIES_FAILED;
}

export type CategoryAction = LoadCategoriesAction | LoadCategoriesSuccessAction | LoadCategoriesFailedAction;



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/actions/category.actions.ts